/**
 * axios setup to use mock service
 * Uses credentials: 'include' for cookie-based auth (no manual Authorization header).
 */

import axios from 'axios';

const axiosServices = axios.create({
    withCredentials: true
});

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default axiosServices;
